import { query } from 'utils/graphql';
import get from 'lodash/get';
import { PLAID_STATUS } from '../../../../constants/plaid';

// Actions
const MAKE_PAYMENT = 'voyager/movein/MAKE_PAYMENT';
const MAKE_PAYMENT_SUCCESS = 'voyager/movein/MAKE_PAYMENT_SUCCESS';
const MAKE_PAYMENT_FAIL = 'voyager/movein/MAKE_PAYMENT_FAIL';
const REVIEW_COST = 'voyager/movein/REVIEW_COST';
const REVIEW_COST_SUCCESS = 'voyager/movein/REVIEW_COST_SUCCESS';
const REVIEW_COST_FAIL = 'voyager/movein/REVIEW_COST_FAIL';
const COMPLETE_TENANT_MOVEIN = 'voyager/movein/COMPLETE_TENANT_MOVEIN';
const COMPLETE_TENANT_MOVEIN_SUCCESS = 'voyager/movein/COMPLETE_TENANT_MOVEIN_SUCCESS';
const COMPLETE_TENANT_MOVEIN_FAIL = 'voyager/movein/COMPLETE_TENANT_MOVEIN_FAIL';
const COMPLETE_STORABLE_TENANT_MOVEIN = 'voyager/movein/COMPLETE_STORABLE_TENANT_MOVEIN';
const COMPLETE_STORABLE_TENANT_MOVEIN_SUCCESS = 'voyager/movein/COMPLETE_STORABLE_TENANT_MOVEIN_SUCCESS';
const COMPLETE_STORABLE_TENANT_MOVEIN_FAIL = 'voyager/movein/COMPLETE_STORABLE_TENANT_MOVEIN_FAIL';
const UPDATE_PRICING = 'voyager/movein/UPDATE_PRICING';
const UPDATE_SUMMARY = 'voyager/movein/UPDATE_SUMMARY';
const AUTH_TOKEN = 'voyager/movein/AUTH_TOKEN';
const AUTH_TOKEN_SUCCESS = 'voyager/movein/AUTH_TOKEN_SUCCESS';
const AUTH_TOKEN_FAIL = 'voyager/movein/AUTH_TOKEN_FAIL';
const CLEAR_MOVEIN = 'voyager/movein/CLEAR_MOVEIN';
const REFRESH_MOVEIN = 'voyager/movein/REFRESH_MOVEIN';
const CHECK_UNIT_GROUP_AVAILABILITY = 'voyager/movein/CHECK_UNIT_GROUP_AVAILABILITY';
const CHECK_UNIT_GROUP_AVAILABILITY_SUCCESS = 'voyager/movein/CHECK_UNIT_GROUP_AVAILABILITY_SUCCESS';
const CHECK_UNIT_GROUP_AVAILABILITY_FAIL = 'voyager/movein/CHECK_UNIT_GROUP_AVAILABILITY_FAIL';
const FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP = 'voyager/movein/FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP';
const FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP_SUCCESS = 'voyager/movein/FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP_SUCCESS';
const FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP_FAIL = 'voyager/movein/FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP_FAIL';
const STORABLE_CHECKOUT_CONFIRMATION = 'voyager/movein/STORABLE_CHECKOUT_CONFIRMATION';
const STORABLE_CHECKOUT_CONFIRMATION_SUCCESS = 'voyager/movein/STORABLE_CHECKOUT_CONFIRMATION_SUCCESS';
const STORABLE_CHECKOUT_CONFIRMATION_FAIL = 'voyager/movein/STORABLE_CHECKOUT_CONFIRMATION_FAIL';
const STORABLE_GET_LEDGER = 'voyager/movein/STORABLE_GET_LEDGER';
const STORABLE_GET_LEDGER_SUCCESS = 'voyager/movein/STORABLE_GET_LEDGER_SUCCESS';
const STORABLE_GET_LEDGER_FAIL = 'voyager/movein/STORABLE_GET_LEDGER_FAIL';
const CHECK_PROMO_CODE = 'voyager/movein/CHECK_PROMO_CODE';
const CHECK_PROMO_CODE_SUCCESS = 'voyager/movein/CHECK_PROMO_CODE_SUCCESS';
const CHECK_PROMO_CODE_FAIL = 'voyager/movein/CHECK_PROMO_CODE_FAIL';
const REMOVE_APPLIED_PROMOTION = 'voyager/movein/REMOVE_APPLIED_PROMOTION';
const INITIATE_ASYNC_PAYMENT = 'voyager/movein/INITIATE_ASYNC_PAYMENT';
const INITIATE_ASYNC_PAYMENT_SUCCESS = 'voyager/movein/INITIATE_ASYNC_PAYMENT_SUCCESS';
const INITIATE_ASYNC_PAYMENT_FAIL = 'voyager/movein/INITIATE_ASYNC_PAYMENT_FAIL';
const CHECK_PAYMENT_INTENT = 'voyager/movein/CHECK_PAYMENT_INTENT';
const CHECK_PAYMENT_INTENT_SUCCESS = 'voyager/movein/CHECK_PAYMENT_INTENT_SUCCESS';
const CHECK_PAYMENT_INTENT_FAIL = 'voyager/movein/CHECK_PAYMENT_INTENT_FAIL';
const BIN_CHECK = 'voyager/movein/BIN_CHECK';
const BIN_CHECK_SUCCESS = 'voyager/movein/BIN_CHECK_SUCCESS';
const BIN_CHECK_FAIL = 'voyager/movein/BIN_CHECK_FAIL';
const SET_SELECTED_PAYMENT_METHOD_TYPE = 'voyager/movein/SET_SELECTED_PAYMENT_METHOD_TYPE';
const CREATE_PLAID_LINK_TOKEN = 'voyager/movein/CREATE_PLAID_LINK_TOKEN';
const CREATE_PLAID_LINK_TOKEN_SUCCESS = 'voyager/movein/CREATE_PLAID_LINK_TOKEN_SUCCESS';
const CREATE_PLAID_LINK_TOKEN_FAIL = 'voyager/movein/CREATE_PLAID_LINK_TOKEN_FAIL';
const CONNECT_PLAID_ACCOUNT = 'voyager/movein/CONNECT_PLAID_ACCOUNT';
const CONNECT_PLAID_ACCOUNT_SUCCESS = 'voyager/movein/CONNECT_PLAID_ACCOUNT_SUCCESS';
const CONNECT_PLAID_ACCOUNT_FAIL = 'voyager/movein/CONNECT_PLAID_ACCOUNT_FAIL';
const UPDATE_PLAID_STATUS = 'voyager/movein/UPDATE_PLAID_STATUS';

// Reducer
const initialState = {
  loading: false,
  loaded: false,
  tenant: {},
  token: {},
  saving: false,
  authenticating: false,
  authenticated: false,
  availableUnit: {},
  error: null,
  availability: {},
  findingAvailableUnit: false,
  availableUnitResponse: null,
  loadingStorableConfirmation: false,
  storableConfirmationData: undefined,
  storableConfirmationError: undefined,
  loadingStorableLedger: false,
  storableLedgerData: undefined,
  storableLedgerError: undefined,
  checkingPromoCode: false,
  checkPromoCodeData: undefined,
  appliedPromotion: undefined,
  moveInUnitEventId: undefined,
  ledgerId: undefined,
  initiatingAsyncPayment: false,
  asyncPaymentData: undefined,
  asyncPaymentError: undefined,
  checkingPaymentIntent: false,
  paymentIntentData: undefined,
  paymentIntentError: undefined,
  checkingBin: false,
  binCheckData: undefined,
  binCheckError: undefined,
  selectedPaymentMethodType: undefined,
  plaidLinkTokenData: undefined,
  plaidAccountData: undefined,
  plaidStatus: PLAID_STATUS.NotStarted,
  plaidError: undefined,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case MAKE_PAYMENT:
      return {
        ...state,
        saving: true,
      };
    case MAKE_PAYMENT_SUCCESS:
      return {
        ...state,
        saving: false,
        tenantId: action.data.id,
      };
    case MAKE_PAYMENT_FAIL:
      return {
        ...state,
        error: action.error.map(err => err.message),
        saving: false,
      };
    case COMPLETE_TENANT_MOVEIN:
      return {
        ...state,
        saving: true,
      };
    case COMPLETE_TENANT_MOVEIN_SUCCESS:
      return {
        ...state,
        saving: false,
        tenant: action.data.completingTenantMoveIn.tenant,
        unit: action.data.completingTenantMoveIn.unit,
      };
    case COMPLETE_TENANT_MOVEIN_FAIL:
      return {
        ...state,
        saving: false,
        tenant: {
          ...state.tenant,
          error: action.error || 'Unable to complete move-in',
        },
      };
    case COMPLETE_STORABLE_TENANT_MOVEIN:
      return {
        ...state,
        saving: true,
      };
    case COMPLETE_STORABLE_TENANT_MOVEIN_SUCCESS:
      return {
        ...state,
        saving: false,
        tenantId: get(action, 'data.storableTenantMoveIn.tenant.id'),
        unitId: get(action, 'data.storableTenantMoveIn.unit.id'),
        unitName: get(action, 'data.storableTenantMoveIn.unit.name'),
        moveInUnitEventId: get(action, 'data.storableTenantMoveIn.moveInUnitEventId'),
        ledgerId: get(action, 'data.storableTenantMoveIn.ledgerId'),
        error: get(action, 'data.storableTenantMoveIn.error'),
      };
    case COMPLETE_STORABLE_TENANT_MOVEIN_FAIL:
      return {
        ...state,
        saving: false,
        error: action.error.message,
      };
    case REVIEW_COST:
      return {
        ...state,
        saving: true,
        error: null,
      };
    case REVIEW_COST_SUCCESS:
      return {
        ...state,
        reviewedFacilityId: action.facilityId,
        reviewedUnitGroupId: action.unitGroupId,
        moveInDate: action.moveInDate || state.moveInDate,
        saving: false,
        pricing: action.data.reviewCost.pricing,
      };
    case REVIEW_COST_FAIL:
      return {
        ...state,
        saving: false,
        availableUnit: {
          ...state.availableUnit,
          error: action.error,
          errorMessage: action.error.response.body.errors[0].message,
        },
      };
    case CHECK_UNIT_GROUP_AVAILABILITY:
      return {
        ...state,
        saving: true,
        error: null,
      };
    case CHECK_UNIT_GROUP_AVAILABILITY_SUCCESS:
      return {
        ...state,
        reviewedFacilityId: action.facilityId,
        reviewedUnitGroupId: action.unitGroupId,
        saving: false,
        availability: action.data.checkUnitGroupAvailability,
      };
    case CHECK_UNIT_GROUP_AVAILABILITY_FAIL:
      return {
        ...state,
        saving: false,
        availability: { available: false },
      };
    case UPDATE_PRICING:
      return {
        ...state,
        moveInDate: action.date,
      };
    case UPDATE_SUMMARY:
      return {
        ...state,
        nextChargeAmount: action.nextChargeAmount,
        unitGroupId: action.unitGroupId,
        facilityId: action.facilityId,
      };
    case AUTH_TOKEN:
      return {
        ...state,
        authenticating: true,
        authenticated: false,
      };
    case AUTH_TOKEN_SUCCESS:
      return {
        ...state,
        authenticating: false,
        authenticated: true,
        ...action.data.authToken,
      };
    case AUTH_TOKEN_FAIL:
      return {
        ...state,
        error: action.error.map(err => err.message),
        authenticating: false,
        authenticated: false,
      };
    case CLEAR_MOVEIN:
      return {
        ...initialState,
      };
    case REFRESH_MOVEIN:
      return {
        ...state,
        tenant: action.tenant,
        unit: action.unit,
      };
    case FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP:
      return {
        ...state,
        findingAvailableUnit: true,
        availableUnitResponse: null,
      };
    case FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP_SUCCESS:
      return {
        ...state,
        findingAvailableUnit: false,
        availableUnitResponse: action.data.firstAvailableUnitFromUnitGroup,
      };
    case FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP_FAIL:
      return {
        ...state,
        findingAvailableUnit: false,
        availableUnitResponse: { success: false, error: 'There was an error when trying to find the first available unit' },
      };
    case STORABLE_CHECKOUT_CONFIRMATION:
      return {
        ...state,
        loadingStorableConfirmation: true,
        storableConfirmationData: undefined,
        storableConfirmationError: undefined,
      };
    case STORABLE_CHECKOUT_CONFIRMATION_SUCCESS:
      return {
        ...state,
        loadingStorableConfirmation: false,
        storableConfirmationData: action.data.storableCheckoutConfirmation,
      };
    case STORABLE_CHECKOUT_CONFIRMATION_FAIL:
      return {
        ...state,
        loadingStorableConfirmation: false,
        storableConfirmationError: { success: false, error: 'There was an error loading the checkout confirmation' },
      };
    case STORABLE_GET_LEDGER:
      return {
        ...state,
        loadingStorableLedger: true,
        storableLedgerData: undefined,
        storableLedgerError: undefined,
      };
    case STORABLE_GET_LEDGER_SUCCESS:
      return {
        ...state,
        loadingStorableLedger: false,
        storableLedgerData: action.data.ledger || action.data.ledgerWithAddons,
      };
    case STORABLE_GET_LEDGER_FAIL:
      return {
        ...state,
        loadingStorableLedger: false,
        storableLedgerError: { success: false, error: 'There was an error loading the ledger' },
      };
    case CHECK_PROMO_CODE:
      return {
        ...state,
        checkingPromoCode: true,
        checkPromoCodeData: undefined,
        appliedPromotion: undefined,
      };
    case CHECK_PROMO_CODE_SUCCESS:
      return {
        ...state,
        checkingPromoCode: false,
        checkPromoCodeData: action.data.checkPromoCode,
        appliedPromotion: action.data.checkPromoCode.discountPlan,
      };
    case CHECK_PROMO_CODE_FAIL:
      return {
        ...state,
        checkingPromoCode: false,
        checkPromoCodeData: { success: false },
      };
    case REMOVE_APPLIED_PROMOTION:
      return {
        ...state,
        appliedPromotion: undefined,
      };
    case INITIATE_ASYNC_PAYMENT:
      return {
        ...state,
        initiatingAsyncPayment: true,
        asyncPaymentData: undefined,
        asyncPaymentError: undefined,
      };
    case INITIATE_ASYNC_PAYMENT_SUCCESS:
      return {
        ...state,
        initiatingAsyncPayment: false,
        asyncPaymentData: action.data.initiateAsyncPayment,
      };
    case INITIATE_ASYNC_PAYMENT_FAIL:
      return {
        ...state,
        initiatingAsyncPayment: false,
        asyncPaymentData: { success: false },
        asyncPaymentError: action.error,
      };
    case CHECK_PAYMENT_INTENT:
      return {
        ...state,
        checkingPaymentIntent: true,
        paymentIntentData: undefined,
        paymentIntentError: undefined,
      };
    case CHECK_PAYMENT_INTENT_SUCCESS:
      return {
        ...state,
        checkingPaymentIntent: false,
        paymentIntentData: action.data.checkPaymentIntent,
      };
    case CHECK_PAYMENT_INTENT_FAIL:
      return {
        ...state,
        checkingPaymentIntent: false,
        paymentIntentError: action.error,
      };
    case BIN_CHECK:
      return {
        ...state,
        checkingBin: true,
        binCheckData: undefined,
        binCheckError: undefined,
      };
    case BIN_CHECK_SUCCESS:
      return {
        ...state,
        checkingBin: false,
        binCheckData: action.data.binCheck,
      };
    case BIN_CHECK_FAIL:
      return {
        ...state,
        checkingBin: false,
        binCheckError: action.error,
      };
    case SET_SELECTED_PAYMENT_METHOD_TYPE:
      return {
        ...state,
        selectedPaymentMethodType: action.selectedPaymentMethodType,
      };
    case CREATE_PLAID_LINK_TOKEN:
      return {
        ...state,
        plaidLinkTokenData: undefined,
        plaidStatus: PLAID_STATUS.LoadingLinkToken,
        plaidError: undefined,
      };
    case CREATE_PLAID_LINK_TOKEN_SUCCESS:
      return {
        ...state,
        plaidLinkTokenData: action.data.createPlaidLinkToken,
        plaidStatus: PLAID_STATUS.ReadyToConnect,
        plaidError: undefined,
      };
    case CREATE_PLAID_LINK_TOKEN_FAIL:
      return {
        ...state,
        plaidStatus: PLAID_STATUS.Error,
        plaidError: action.error?.[0]?.message,
      };
    case CONNECT_PLAID_ACCOUNT:
      return {
        ...state,
        plaidAccountData: undefined,
        plaidStatus: PLAID_STATUS.VerifyingAccount,
        plaidError: undefined,
      };
    case CONNECT_PLAID_ACCOUNT_SUCCESS:
      return {
        ...state,
        plaidAccountData: action.data.connectPlaidAccount,
        plaidStatus: PLAID_STATUS.Connected,
        plaidError: undefined,
      };
    case CONNECT_PLAID_ACCOUNT_FAIL:
      return {
        ...state,
        plaidStatus: PLAID_STATUS.Error,
        plaidError: action.error?.[0]?.message,
      };
    case UPDATE_PLAID_STATUS:
      return {
        ...state,
        plaidStatus: action.plaidStatus,
      };
    default:
      return state;
  }
}

// Selectors
export const getMoveInUnitEventId = state => (
  state.movein.moveInUnitEventId
);

export const getLedgerId = state => (
  state.movein.ledgerId
);

export const getIsInitiatingAsyncPayment = state => (
  state.movein.initiatingAsyncPayment
);

export const isCheckingPaymentIntent = state => (
  state.movein.checkingPaymentIntent
);

export const getAsyncPaymentData = state => (
  state.movein.asyncPaymentData
);

export const getPaymentIntentData = state => (
  state.movein.paymentIntentData
);

export const getPaymentIntentError = state => (
  state.movein.paymentIntentError
);

export const getAsyncPaymentError = state => (
  state.movein.asyncPaymentError
);

export const getBinCheckData = state => (
  state.movein.binCheckData
);

export const getSelectedPaymentMethodType = state => (
  state.movein.selectedPaymentMethodType
);

export const getPlaidLinkTokenData = state => (
  state.movein.plaidLinkTokenData
);

export const getPlaidAccountData = state => (
  state.movein.plaidAccountData
);

export const getPlaidStatus = state => (
  state.movein.plaidStatus
);

export const getPlaidError = state => (
  state.movein.plaidError
);

// Actions
export function clearMoveIn() {
  return {
    type: CLEAR_MOVEIN,
  };
}

export function updatePricing(date) {
  return {
    type: UPDATE_PRICING,
    date,
  };
}

export function refreshMoveInData(tenant, unit) {
  return {
    type: REFRESH_MOVEIN,
    tenant,
    unit,
  };
}

export function updateSummary(nextChargeAmount, unitGroupId, facilityId) {
  return {
    type: UPDATE_SUMMARY,
    nextChargeAmount,
    unitGroupId,
    facilityId,
  };
}

export function removeAppliedPromotion() {
  return {
    type: REMOVE_APPLIED_PROMOTION,
  };
}

export function setSelectedPaymentMethodType(selectedPaymentMethodType) {
  return {
    type: SET_SELECTED_PAYMENT_METHOD_TYPE,
    selectedPaymentMethodType,
  };
}

export function reviewCost(unitGroupId, facilityId, pricingTypeId, moveInDate, discountPlanIds, leadId, invoiceableItems, insuranceId) {
  return {
    types: [REVIEW_COST, REVIEW_COST_SUCCESS, REVIEW_COST_FAIL],
    unitGroupId,
    facilityId,
    pricingTypeId,
    moveInDate,
    discountPlanIds,
    leadId,
    invoiceableItems,
    insuranceId,
    force: true,
    promise: query`
      mutation ReviewCost(${{ unitGroupId }}: String!, ${{ facilityId }}: String!, ${{ pricingTypeId }}: Int, ${{ moveInDate }}: String, ${{ discountPlanIds }}: [String], ${{ leadId }}: String, ${{ invoiceableItems }}: [InvoiceableItemInput], ${{insuranceId}}: String) {
        reviewCost(unitGroupId: $unitGroupId, facilityId: $facilityId, pricingTypeId: $pricingTypeId, moveInDate: $moveInDate, discountPlanIds: $discountPlanIds, leadId: $leadId, invoiceableItems: $invoiceableItems, insuranceId: $insuranceId) {
          success
          error
          pricing {
            discountPlans {
              id
              name
              amount
              publicDescription
              discountPlanDiscounts {
                amount
              }
            }
            dueAtMoveIn
            dueFirstMonth
            invoiceableFees {
              description
              fullDescription
              amount
              discountAmount
              quantity
            }
            moveInDate
            nextDueDate
            proratedCredit
            taxAmount
            surchargeAmount
            dueAtMoveInWithSurcharge
          }
        }
      }
    `,
  };
}

export function checkUnitGroupAvailability(unitGroupId, facilityId) {
  return {
    types: [CHECK_UNIT_GROUP_AVAILABILITY, CHECK_UNIT_GROUP_AVAILABILITY_SUCCESS, CHECK_UNIT_GROUP_AVAILABILITY_FAIL],
    unitGroupId,
    facilityId,
    force: true,
    promise: query`
      mutation CheckUnitGroupAvailability(${{ unitGroupId }}: String!, ${{ facilityId }}: String!) {
        checkUnitGroupAvailability(unitGroupId: $unitGroupId, facilityId: $facilityId) {
          available
          error
        }
      }
    `,
  };
}

export function getFirstAvailableUnitFromUnitGroup(unitGroupId, facilityId, isFacilityGB) {
  return {
    types: [FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP, FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP_SUCCESS, FIRST_AVAILABLE_UNIT_FROM_UNIT_GROUP_FAIL],
    unitGroupId,
    facilityId,
    isFacilityGB,
    force: true,
    promise: query`
      query GetFirstAvailableUnitFromUnitGroup(${{ unitGroupId }}: String!, ${{ facilityId }}: String!, ${{ isFacilityGB }}: Boolean!) {
        firstAvailableUnitFromUnitGroup(unitGroupId: $unitGroupId, facilityId: $facilityId, isFacilityGB: $isFacilityGB) {
          success
          error
          units {
            id
            name
            price
            length
            width
            size
            tier {
              id
              rank
            }
            custom_fields {
              name
              value
            }
          }
        }
      }
    `,
  };
}

export function completingTenantMovein(facilityId, paymentMethod, moveIn, address) {
  return {
    types: [COMPLETE_TENANT_MOVEIN, COMPLETE_TENANT_MOVEIN_SUCCESS, COMPLETE_TENANT_MOVEIN_FAIL],
    facilityId,
    force: true,
    promise: query`
      mutation CompletingTenantMoveIn(
      ${{ facilityId }}: String!, ${{ paymentMethod }}: PaymentMethod!,
        ${{ moveIn }}: MoveInInput!, ${{ address }}: AddressInput!) {
        completingTenantMoveIn(facilityId: $facilityId, paymentMethod: $paymentMethod,
          moveIn: $moveIn, address: $address){
          tenant {
            id
          }
          unit {
            id
            name
          }
        }
      }
    `,
  };
}

export function storableTenantMovein({ facilityId, tenantId, unitId, leadId, moveInDate, paymentMethod, invoiceableItems, insuranceId, discountPlanIds, storedGoodsValue }) {
  return {
    types: [COMPLETE_STORABLE_TENANT_MOVEIN, COMPLETE_STORABLE_TENANT_MOVEIN_SUCCESS, COMPLETE_STORABLE_TENANT_MOVEIN_FAIL],
    facilityId,
    force: true,
    promise: query`
      mutation StorableTenantMoveIn(
      ${{ facilityId }}: String!, ${{ leadId }}: String!, ${{ paymentMethod }}: PaymentMethod,
      ${{ tenantId }}: String!, ${{ unitId }}: String!, ${{ moveInDate }}: String!, ${{ invoiceableItems }}: [InvoiceableItemInput],
      ${{ insuranceId }}: String, ${{ discountPlanIds }}: [String], ${{ storedGoodsValue }}: String) {
        storableTenantMoveIn(facilityId: $facilityId, leadId: $leadId, paymentMethod: $paymentMethod,
        tenantId: $tenantId, unitId: $unitId, moveInDate: $moveInDate, invoiceableItems: $invoiceableItems,
        insuranceId: $insuranceId, discountPlanIds: $discountPlanIds, storedGoodsValue: $storedGoodsValue) {
          success
          error
          id
          moveInUnitEventId
          ledgerId
          unit {
            id
            name
          }
          tenant {
            id
          }
        }
      }
    `,
  };
}

export function storableCheckoutConfirmation(facilityId, moveInUnitEventId) {
  return {
    types: [STORABLE_CHECKOUT_CONFIRMATION, STORABLE_CHECKOUT_CONFIRMATION_SUCCESS, STORABLE_CHECKOUT_CONFIRMATION_FAIL],
    facilityId,
    moveInUnitEventId,
    force: true,
    promise: query`
      query StorableCheckoutConfirmation(${{ facilityId }}: String!, ${{ moveInUnitEventId }}: String!) {
        storableCheckoutConfirmation(facilityId: $facilityId, moveInUnitEventId: $moveInUnitEventId) {
          success
          error
          id
          ledger_id
          unit_name
          tenant_name
          move_in_subtotal
          move_in_taxes_total
          move_in_total
          move_in_total_with_surcharge
          esign_url
          invoice_line_items {
            description
            full_description
            subtotal
            total
            tax_total
            quantity
            discount_amount
          }
          successful_payment_events {
            amount
            payment_method {
              card_number
              card_type
              account_number
              bank_name
              account_type
            }
          }
          applied_discount_plans {
            id
            name
            amount
          }
          surcharge {
            fee
          }
        }
      }
    `,
  };
}

export function makePayment(facilityId, paymentInput) {
  return {
    types: [MAKE_PAYMENT, MAKE_PAYMENT_SUCCESS, MAKE_PAYMENT_FAIL],
    force: true,
    promise: query`
      mutation MakePayment(${{ facilityId }}: String!, ${{ paymentInput }}: PaymentInput!) {
        makePayment(facilityId: $facilityId, paymentInput: $paymentInput) {
          id
        }
      }
    `,
  };
}

export function authToken(token) {
  return {
    types: [AUTH_TOKEN, AUTH_TOKEN_SUCCESS, AUTH_TOKEN_FAIL],
    force: true,
    promise: query`
      mutation AuthToken(${{ token }}: String!) {
        authToken(token: $token) {
          ledgerId
          nextChargeAmount
          tenantId
          tokenUnitGroupId
          tokenFacilityId
          accessToken
          unit {
            name
            size
          }
          discountId
          discountName
        }
      }
    `,
  };
}

export function getLedger(facilityId, ledgerId) {
  return {
    types: [STORABLE_GET_LEDGER, STORABLE_GET_LEDGER_SUCCESS, STORABLE_GET_LEDGER_FAIL],
    facilityId,
    ledgerId,
    force: true,
    promise: query`
      query GetLedger(${{ facilityId }}: String!, ${{ ledgerId }}: String!) {
        ledger(facilityId: $facilityId, ledgerId: $ledgerId) {
          success
          error
          id
          moved_in_at
          autopay_info {
           autopay_enabled
          }
          tenant {
            first_name
            last_name
            email
            phone_numbers {
              formatted_number
              primary
              sms_opt_in
            }
            mailing_address {
              address1
              address2
              city
              state
              postal
            }
            contacts {
              first_name
              last_name
              primary
              description
              phone_numbers {
                formatted_number
                primary
              }
            }
          }
          unit {
            id
            name
            price
            length
            width
            height
            unit_type {
              name
            }
            unit_amenities {
              name
              token
              short_code
            }
            unit_group_id
          }
        }
      }
    `,
  };
}

export function getLedgerWithAddons(facilityId, ledgerId) {
  return {
    types: [STORABLE_GET_LEDGER, STORABLE_GET_LEDGER_SUCCESS, STORABLE_GET_LEDGER_FAIL],
    facilityId,
    ledgerId,
    force: true,
    promise: query`
      query GetLedgerWithAddons(${{ facilityId }}: String!, ${{ ledgerId }}: String!) {
        ledgerWithAddons(facilityId: $facilityId, ledgerId: $ledgerId) {
          success
          error
          id
          moved_in_at
          autopay_info {
           autopay_enabled
          }
          tenant {
            first_name
            last_name
            email
            phone_numbers {
              formatted_number
              primary
              sms_opt_in
            }
            mailing_address {
              address1
              address2
              city
              state
              postal
            }
            contacts {
              first_name
              last_name
              primary
              description
              phone_numbers {
                formatted_number
                primary
              }
            }
          }
          unit {
            id
            name
            price
            length
            width
            height
            unit_type {
              name
            }
            unit_amenities {
              name
              token
              short_code
            }
            unit_group_id
          }
          discounts {
            id
            name
            kind
            description
          }
        }
      }
    `,
  };
}

export function checkPromoCode(facilityId, unitGroupId, promoCode) {
  return {
    types: [CHECK_PROMO_CODE, CHECK_PROMO_CODE_SUCCESS, CHECK_PROMO_CODE_FAIL],
    force: true,
    promise: query`
      mutation CheckPromoCode(${{ facilityId }}: String!, ${{ unitGroupId }}: String!, ${{ promoCode }}: String!) {
        checkPromoCode(facilityId: $facilityId, unitGroupId: $unitGroupId, promoCode: $promoCode) {
          success
          error
          discountPlan {
            id
            name
          }
        }
      }
    `,
  };
}

export function initiateAsyncPayment(facilityId, ledgerId, paymentAmount) {
  return {
    types: [INITIATE_ASYNC_PAYMENT, INITIATE_ASYNC_PAYMENT_SUCCESS, INITIATE_ASYNC_PAYMENT_FAIL],
    ledgerId,
    facilityId,
    force: true,
    promise: query`
      mutation InitiateAsyncPayment(${{ facilityId }}: String!, ${{ ledgerId }}: String!, ${{ paymentAmount }}: Float!) {
        initiateAsyncPayment(facilityId: $facilityId, ledgerId: $ledgerId, paymentAmount: $paymentAmount) {
          success
          error
          mfeSrcUrl
          paymentIntentId
        }
      }
    `,
  };
}

export function checkPaymentIntent(facilityId, paymentIntentId) {
  return {
    types: [CHECK_PAYMENT_INTENT, CHECK_PAYMENT_INTENT_SUCCESS, CHECK_PAYMENT_INTENT_FAIL],
    paymentIntentId,
    facilityId,
    force: true,
    promise: query`
      query CheckPaymentIntent(${{ facilityId }}: String!, ${{ paymentIntentId }}: String!) {
        paymentIntent(facilityId: $facilityId, paymentIntentId: $paymentIntentId) {
          success
          error
          status
        }
      }
    `,
  };
}

export function binCheck(facilityId, binNumber) {
  return {
    types: [BIN_CHECK, BIN_CHECK_SUCCESS, BIN_CHECK_FAIL],
    force: true,
    promise: query`
      mutation BinCheck(${{ facilityId }}: String!, ${{ binNumber }}: String!) {
        binCheck(facilityId: $facilityId, binNumber: $binNumber) {
          success
          error
          surchargeable

        }
      }
    `,
  };
}

export function createPlaidLinkToken(clientUserId, phoneNumber, locale) {
  return {
    types: [CREATE_PLAID_LINK_TOKEN, CREATE_PLAID_LINK_TOKEN_SUCCESS, CREATE_PLAID_LINK_TOKEN_FAIL],
    clientUserId,
    phoneNumber,
    locale,
    force: true,
    promise: query`
      mutation CreatePlaidLinkToken(${{ clientUserId }}: String!, ${{ phoneNumber }}: String, ${{ locale }}: String!) {
        createPlaidLinkToken(clientUserId: $clientUserId, phoneNumber: $phoneNumber, locale: $locale) {
          expiration
          requestId
          linkToken
        }
      }
    `,
  };
}

export function connectPlaidAccount(publicToken) {
  return {
    types: [CONNECT_PLAID_ACCOUNT, CONNECT_PLAID_ACCOUNT_SUCCESS, CONNECT_PLAID_ACCOUNT_FAIL],
    publicToken,
    force: true,
    promise: query`
      mutation ConnectPlaidAccount(${{ publicToken }}: String!) {
        connectPlaidAccount(publicToken: $publicToken) {
          accountId
          accountName
          accountType
          accountSubtype
          accountNumber
          accountNumberMask
          accountRouting
          holderCategory
          institutionName
        }
      }
    `,
  };
}

export function updatePlaidStatus(plaidStatus) {
  return {
    type: UPDATE_PLAID_STATUS,
    plaidStatus,
  };
}